// src/pages/Authentication/UserProfile/ProfileSidebar.tsx
// Left sidebar with avatar, user info and action buttons

import React from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('authentication');

interface ProfileSidebarProps {
  avatar: string;
  userName: string;
  userRole: string;
  status: 'active' | 'inactive';
  onChangeAvatar: () => void;
}

const ProfileSidebar: React.FC<ProfileSidebarProps> = ({
  avatar,
  userName,
  userRole,
  status,
  onChangeAvatar,
}) => {
  const navigate = useNavigate();

  // Generate avatar URL from UI Avatars if no custom avatar
  const getAvatarUrl = () => {
    if (avatar) return avatar;
    const nameParts = userName?.split(' ');
    const initials = nameParts?.length > 1 
      ? `${nameParts[0]}+${nameParts[nameParts.length - 1]}`
      : userName;
    return `https://ui-avatars.com/api/?name=${initials}&background=0a2d54&color=fff&size=100&bold=true`;
  };

  return (
    <Card>
      <CardBody className="text-center p-4">
        {/* Avatar */}
        <div className="position-relative d-inline-block mb-3">
          <div
            className="avatar-xl rounded-circle border border-3 border-primary overflow-hidden mx-auto"
            style={{ width: '100px', height: '100px' }}
          >
            <img
              src={getAvatarUrl()}
              alt={userName}
              className="img-fluid"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </div>

        {/* User Info */}
        <h5 className="mb-1">{userName}</h5>
        <p className="text-muted mb-2" style={{ fontSize: '13px' }}>
          {userRole}
        </p>

        {/* Status Badge */}
        <span
          className={`badge ${
            status === 'active'
              ? 'bg-success-subtle text-success'
              : 'bg-danger-subtle text-danger'
          }`}
        >
          {status === 'active' ? st('hoat_dong_text') : st('khong_hoat_dong_text')}
        </span>

        <hr className="my-3" />

        {/* Action Buttons */}
        <div className="d-grid gap-2">
          <Button color="primary" outline onClick={onChangeAvatar}>
            <i className="ri-camera-line me-1"></i>
            {st('doi_anh_dai_dien_title')}
          </Button>
          <Button
            color="primary"
            outline
            onClick={() => navigate('/change-password')}
          >
            <i className="ri-lock-password-line me-1"></i>
            {st('doi_mat_khau_button')}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default ProfileSidebar;